import React from "react";

/**
 * The LeafNet mark (the hexagon cube from assets/leafnet-logo.jpg), drawn inline so it
 * stays sharp at any size and sits on the dark new-UI sidebar without a white box.
 * `size` is the height in px. Pass `title` when the logo carries meaning on its own;
 * without it the mark is decorative and hidden from screen readers.
 */
export default function LeafNetLogo({ size = 32, title, className = "" }) {
  return (
    <svg
      className={`ln-logo ${className}`.trim()}
      width={Math.round((size * 106) / 128)}
      height={size}
      viewBox="-3 -3 106 128"
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : "true"}
      focusable="false"
    >
      <polygon
        points="50,0 100,31 100,91 50,122 0,91 0,31"
        fill="#ffffff"
        stroke="#71ae12"
        strokeWidth="5"
      />
      <polygon points="48.5,62 100,31 100,91 48.5,122" fill="#71ae12" />
    </svg>
  );
}
